module.exports = __webpack_public_path__ + "fonts/AntykwaTorunskaLight-Italic.f041f438.ttf";